/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
import {useLoyaltyService} from "../../../services/loyaltyService";

/* Components */
import UCButton from "../../buttons";


/* Styles */
import styles from "./styles.js"


const Content = props => {
  const { setShowModal, row, updateRedemptionList, getLoyaltyList, removeFailedRedemptions } = props;
  const theme = useTheme();
  const classes = styles({ theme });

  const handleDeleteRedemption = async() => {
    let payload = {
      redemptionIds : [row?.redemptionId] ,
      deleteAll: false
    }
    const response = await removeFailedRedemptions(payload)
    if (response) {
      setShowModal(false);
      if (typeof updateRedemptionList === 'function') updateRedemptionList();
      if (typeof getLoyaltyList === 'function') getLoyaltyList();
    }
  }

  return (
    <div className={classes.modalContent}>
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="loyaltyDeleteFailedModal.cancel"/>}
              />
            </Col>
            <Col className={classes.colRemove} >
              <UCButton
                className={classes.deleteBtn}
                onClick={() => handleDeleteRedemption()}
                type="danger"
                text={<FormattedMessage id="loyaltyDeleteFailedModal.delete"/>}
                spinner={{
                  name: "deleteRedemptionSpinner",
                  size: 20,
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default Content;
